export class FlowControlledDataChannel {
    log = null;
    dc;
    highWaterMark;
    _ready = new Future();
    constructor(dc, logService, logLevel, lowWaterMark = 256 * 1024, highWaterMark = 1024 * 1024) {
        this.log = logService.getLogger(`FlowControlledDataChannel.${dc.id}`, 'color: #fff; background-color: #009688', logLevel);
        this.dc = dc;
        this.highWaterMark = highWaterMark;
        this._ready.resolve();
        this.dc.bufferedAmountLowThreshold = lowWaterMark;
        this.dc.onbufferedamountlow = () => {
            if (!this._ready.done) {
                this.log.debug(`${this.dc.label} resumed (buffered=${this.dc.bufferedAmount})`);
                this._ready.resolve();
            }
        };
    }
    get ready() {
        return this._ready;
    }
    write(message) {
        if (!this._ready.done) {
            throw new Error('Unable to write, data channel is paused!');
        }
        this.dc.send(message);
        if (this.dc.bufferedAmount >= this.highWaterMark) {
            this._ready = new Future();
            this.log.debug(`${this.dc.label} paused (buffered=${this.dc.bufferedAmount})`);
        }
    }
}
export class UnboundedFlowControlledDataChannel extends FlowControlledDataChannel {
    queue = this.ready;
    write(message) {
        this.queue = this.queue.then(() => this.writeWhenReady(message));
    }
    async writeWhenReady(message) {
        await this.ready;
        super.write(message);
    }
}
